import styled from '@emotion/styled'
import React, { ComponentProps } from 'react'

import { theme } from '@emico/styles'

import ButtonUnstyled from './ButtonUnstyled'

export interface ButtonIconProps extends ComponentProps<typeof ButtonUnstyled> {
  label: string
  showLabel?: boolean
}

const StyledButtonIcon = styled(ButtonUnstyled)`
  color: ${theme.onBackgroundColor};
  cursor: pointer;
  fill: currentColor;

  &:focus {
    color: ${theme.secondaryColor};
  }

  &:active {
    color: ${theme.gray500};
  }
`

const Label = styled.span`
  margin-right: ${theme.spacing.x1}px;
`

const ButtonIcon = ({
  label,
  showLabel,
  children,
  ...props
}: ButtonIconProps) => (
  <StyledButtonIcon {...props} aria-label={!showLabel ? label : undefined}>
    {showLabel && <Label>{label}</Label>}

    <span aria-hidden="true">{children}</span>
  </StyledButtonIcon>
)

export default ButtonIcon
